module.exports = __webpack_public_path__ + "static/media/logo@2x.5eb81110.png";